import React, { useState } from 'react';


const Logo = () => (
  <img className="logo-img" src="/unshoot-logo-cropped.svg" alt="unshoot.ai" style={{height:70,width:"auto"}}/>
);

const checks = (items, dark) => items.map((f, i) => (
  <li key={i} style={{fontSize:13,color:dark?"rgba(255,255,255,.65)":"#444",padding:"10px 0",fontSize:16,borderBottom:`.5px solid ${dark?"rgba(255,255,255,.08)":"#e8eaed"}`,display:"flex",alignItems:"center",gap:10}}>
    <span style={{width:16,height:16,borderRadius:"50%",background:dark?"rgba(255,255,255,.1)":"#f1f3f5",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
      <svg width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1.5 4l2 2 3-3" stroke={dark?"rgba(255,255,255,.7)":"#111"} strokeWidth="1.3" strokeLinecap="round"/></svg>
    </span>
    {f}
  </li>
));

export default function App() {
  const [open, setOpen] = useState(false);
  const [done, setDone] = useState(false);
  const [form, setForm] = useState({name:"",company:"",email:"",phone:""});
  const go = e => { e.preventDefault(); setOpen(true); };
  const set = e => setForm({...form,[e.target.name]:e.target.value});
  const SHEET_URL = "https://script.google.com/macros/s/AKfycbw_JlgccFDk4tDcMmKAWgbXXoKxTVyTfrtCVMcxRfeXJrWFNYPrz0mSLnfrmsQrDgY1TA/exec";
  const sub = async e => {
    e.preventDefault();
    try {
      await fetch(SHEET_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(form)
      });
    } catch(err) {}
    setDone(true);
  };

  return (
    <div style={{fontFamily:"'Inter',system-ui,sans-serif",background:"#fff",color:"#111",overflowX:"hidden"}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
        html{scroll-behavior:smooth;}
        @keyframes fadeUp{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}
        .f1{animation:fadeUp .5s ease .05s both}.f2{animation:fadeUp .5s ease .15s both}
        .f3{animation:fadeUp .5s ease .25s both}.f4{animation:fadeUp .5s ease .35s both}
        .f5{animation:fadeUp .5s ease .45s both}
        .after-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;}
        .after-carousel{display:none;}
        .ba-grid{display:grid;grid-template-columns:1fr auto 3fr;gap:16px;align-items:start;}
        .mobile-results{display:none;}
        @media(max-width:700px){.ba-grid{display:none !important;}.mobile-results{display:block;}.after-carousel{display:flex;gap:12px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding-bottom:8px;}.after-carousel::-webkit-scrollbar{display:none;}.after-carousel-item{flex:0 0 80vw;scroll-snap-align:start;}}
        .ht-desktop{display:block;}.ht-mobile{display:none;}.hs-desktop{display:block;}.hs-mobile{display:none;}
        @media(max-width:700px){.ht-desktop{display:none;}.ht-mobile{display:block;}.hs-desktop{display:none;}.hs-mobile{display:block;}}
        @media(max-width:700px){.ba-grid{grid-template-columns:1fr;}.ba-arrow{display:none;}.pain-grid{grid-template-columns:1fr !important;gap:24px !important;}.pain-img{order:-1;}.cmp-header{padding:14px 16px !important;}.cmp-row{padding:14px 16px !important;font-size:13px !important;}.cmp-pill{font-size:13px !important;padding:3px 8px !important;}.logo-img{height:44px !important;}.ht{font-size:40px !important;}}
        .nav{position:sticky;top:0;z-index:100;display:flex;align-items:center;justify-content:space-between;padding:20px 32px;background:rgba(255,255,255,.97);backdrop-filter:blur(8px);border-bottom:.5px solid #e8eaed;}
        .nav-hide-mobile{display:none;}
        @media(min-width:700px){.nav-hide-mobile{display:block;}}
        .ncta{background:#111;color:#fff;padding:14px 32px;border-radius:100px;font-size:16px;font-weight:600;cursor:pointer;border:none;transition:background .15s;}
        .ncta:hover{background:#333;}
        .hero{display:flex;flex-direction:column;}
        @media(min-width:700px){.hero{flex-direction:row;min-height:88vh;}}
        .hl{display:flex;flex-direction:column;padding:40px 20px 36px;}
        @media(min-width:700px){.hl{flex:1;padding:64px 52px;justify-content:center;}}
        .pill{display:inline-flex;background:#f1f3f5;border:.5px solid #d1d5db;color:#374151;font-size:11px;font-weight:500;letter-spacing:.8px;text-transform:uppercase;padding:5px 12px;border-radius:4px;margin-bottom:22px;align-self:flex-start;}
        .ey{font-size:12px;font-weight:500;letter-spacing:1.5px;text-transform:uppercase;color:#6b7280;margin-bottom:12px;}
        .ht{font-size:clamp(40px,6vw,64px);font-weight:700;line-height:1.03;letter-spacing:-2px;margin-bottom:20px;}
        .hs{font-size:20px;color:#6b7280;line-height:1.7;margin-bottom:36px;max-width:480px;}
        .ha{display:flex;flex-direction:column;gap:10px;}
        @media(min-width:700px){.ha{flex-direction:row;align-items:center;}}
        .bp{background:#111;color:#fff;padding:18px 36px;border-radius:100px;font-size:18px;font-weight:600;cursor:pointer;border:none;transition:background .15s;letter-spacing:-.2px;}
        .bp:hover{background:#333;}
        .bg{color:#111;font-size:14px;cursor:pointer;background:none;border:none;padding:12px 20px;border:.5px solid #d1d5db;border-radius:6px;transition:border-color .15s;}
        .bg:hover{border-color:#9ca3af;}
        @media(min-width:700px){.bg{padding:0;border:none;border-bottom:1px solid #d1d5db;border-radius:0;background:transparent;}}
        
        .hr{position:relative;height:420px;overflow:hidden;background:#f1f3f5;}
        @media(min-width:700px){.hr{flex:1;height:auto;}}
        .is{display:flex;height:100%;}
        .mc{flex:1;border-right:2px solid #fff;overflow:hidden;position:relative;}
        .mc:last-child{border-right:none;}
        .mb{width:100%;height:100%;display:flex;flex-direction:column;justify-content:flex-end;padding:14px 10px;position:relative;}
        .mb::before{content:none;}
        .mt{position:absolute;bottom:16px;left:14px;z-index:3;font-size:11px;font-weight:500;letter-spacing:1.5px;text-transform:uppercase;color:#111;background:none;border-bottom:1.5px solid #111;padding-bottom:2px;}
        .hb{position:absolute;top:14px;right:14px;background:rgba(255,255,255,0.92);color:#111;padding:6px 14px;border-radius:100px;font-size:11px;font-weight:600;z-index:10;letter-spacing:.5px;border:.5px solid rgba(0,0,0,.12);backdrop-filter:blur(4px);}
        .dv{height:.5px;background:#e8eaed;}
        .sec{padding:60px 20px;}
        @media(min-width:700px){.sec{padding:96px 52px;}}
        .sb{background:#f8f9fa;}
        .sl2{font-size:12px;font-weight:500;letter-spacing:1.5px;text-transform:uppercase;color:#6b7280;margin-bottom:10px;}
        .st{font-size:clamp(24px,5.5vw,40px);font-weight:700;line-height:1.1;letter-spacing:-.5px;margin-bottom:12px;}
        .sd{font-size:18px;color:#6b7280;line-height:1.75;max-width:560px;}
        .hg{display:flex;flex-direction:column;gap:1px;margin-top:40px;background:#e8eaed;border:.5px solid #e8eaed;border-radius:10px;overflow:hidden;}
        @media(min-width:700px){.hg{flex-direction:row;}}
        .hc{background:#fff;padding:28px 24px;display:flex;gap:18px;align-items:flex-start;flex:1;}
        @media(min-width:700px){.hc{flex-direction:column;gap:0;padding:40px 36px;}}
        .hn{font-size:40px;font-weight:700;color:#e8eaed;line-height:1;letter-spacing:-2px;flex-shrink:0;width:52px;}
        @media(min-width:700px){.hn{font-size:72px;width:auto;margin-bottom:24px;}}
        .htn{font-size:22px;font-weight:600;margin-bottom:10px;}
        .htd{font-size:16px;color:#6b7280;line-height:1.65;}
        .fg{display:flex;flex-direction:column;gap:12px;margin-top:40px;}
        @media(min-width:700px){.fg{display:grid;grid-template-columns:repeat(2,1fr);gap:0;border:.5px solid #e8eaed;border-radius:10px;overflow:hidden;}}
        .fc{padding:40px;border:.5px solid #e8eaed;background:#fff;transition:background .15s;}
        .fc:hover{background:#f8f9fa;}
        
        
        
        .fi{width:36px;height:36px;background:#f1f3f5;border-radius:8px;display:flex;align-items:center;justify-content:center;margin-bottom:14px;}
        .fcw .fi{background:rgba(255,255,255,.08);}
        .ftt{font-size:22px;font-weight:600;margin-bottom:8px;}
        .fcw .ftt{color:#fff;}
        .fdd{font-size:17px;color:#6b7280;line-height:1.65;}
        .fcw .fdd{color:rgba(255,255,255,.5);}
        .bn{font-size:72px;font-weight:700;letter-spacing:-3px;color:#fff;line-height:1;}
        .bl{font-size:12px;color:rgba(255,255,255,.35);margin-top:4px;text-align:right;}
        .wmb{margin-top:20px;padding-top:18px;border-top:.5px solid rgba(255,255,255,.1);display:flex;align-items:baseline;justify-content:space-between;}
        @media(min-width:700px){.wmb{display:none;}}
        .wdt{display:none;flex-shrink:0;text-align:right;}
        @media(min-width:700px){.wdt{display:block;}}
        .pg{display:flex;flex-direction:column;gap:12px;margin-top:40px;}
        @media(min-width:700px){.pg{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;}}
        .pc{background:#fff;border-radius:10px;padding:28px;border:.5px solid #e8eaed;position:relative;}
        .pop{background:#111;color:#fff;border-color:transparent;margin-top:10px;}
        @media(min-width:700px){.pop{margin-top:0;}}
        .pb{position:absolute;top:-11px;left:50%;transform:translateX(-50%);background:#111;color:#fff;font-size:11px;font-weight:500;letter-spacing:.8px;text-transform:uppercase;padding:4px 12px;border-radius:4px;white-space:nowrap;}
        .pn{font-size:12px;font-weight:600;letter-spacing:1.2px;text-transform:uppercase;color:#9ca3af;margin-bottom:14px;}
        .pop .pn{color:rgba(255,255,255,.4);}
        .pp{font-size:40px;font-weight:700;letter-spacing:-1.5px;line-height:1;margin-bottom:4px;}
        .ps{font-size:20px;font-weight:400;color:#9ca3af;text-decoration:line-through;margin-left:8px;vertical-align:middle;}
        .pop .ps{color:rgba(255,255,255,.35);}
        .pr{font-size:13px;color:#9ca3af;margin-bottom:22px;}
        .pop .pr{color:rgba(255,255,255,.4);}
        .pf{list-style:none;margin-bottom:24px;}
        .pb2{display:block;width:100%;text-align:center;padding:16px;border-radius:100px;font-size:16px;font-weight:600;cursor:pointer;border:.5px solid #d1d5db;color:#111;background:transparent;transition:background .15s;}
        .pb2:hover{background:#f1f3f5;}
        .pop .pb2{background:#fff;color:#111;border-color:transparent;}
        .pop .pb2:hover{background:#e8eaed;}
        .bag{display:flex;flex-direction:column;gap:24px;margin-top:40px;}
        .bap{display:grid;grid-template-columns:1fr auto 1fr;gap:12px;align-items:center;max-width:600px;margin:0 auto;}
        .bas{display:flex;flex-direction:column;}
        .basl{margin-top:8px;font-size:12px;font-weight:500;letter-spacing:1px;text-transform:uppercase;color:#9ca3af;text-align:center;}
        .bai{border-radius:10px;overflow:hidden;position:relative;display:flex;align-items:center;justify-content:center;}
        .bab{width:100%;aspect-ratio:2/3;background:#e8eaed;}
        .baa{width:100%;aspect-ratio:2/3;background:#d4d8dd;}
        .bac{position:absolute;bottom:10px;left:10px;font-size:11px;font-weight:600;letter-spacing:1px;text-transform:uppercase;padding:4px 10px;border-radius:4px;z-index:2;}
        .bac.bb{background:rgba(255,255,255,.92);color:#374151;}
        .bac.ba{background:#111;color:#fff;}
        .baarr{display:flex;flex-direction:column;align-items:center;gap:4px;flex-shrink:0;}
        .bal{width:1px;height:28px;background:#d1d5db;}
        .baic{width:28px;height:28px;border-radius:50%;border:.5px solid #d1d5db;background:#fff;display:flex;align-items:center;justify-content:center;}
        .bam{margin-top:10px;display:flex;align-items:center;justify-content:center;gap:8px;}
        .balab{font-size:13px;font-weight:500;color:#374151;}
        .basu{font-size:12px;color:#9ca3af;}
        .cta{background:#111;color:#fff;padding:80px 20px;text-align:center;}
        .ctat{font-size:clamp(30px,7vw,50px);font-weight:700;line-height:1.08;letter-spacing:-1px;margin-bottom:14px;}
        .ctas{font-size:14px;color:rgba(255,255,255,.45);margin-bottom:32px;}
        .ba2{background:#fff;color:#111;padding:18px 40px;border-radius:100px;font-size:18px;font-weight:600;cursor:pointer;border:none;transition:background .15s;}
        .ba2:hover{background:#e8eaed;}
        footer{background:#111;color:rgba(255,255,255,.3);padding:18px 20px;display:flex;flex-direction:column;gap:10px;align-items:center;text-align:center;border-top:.5px solid rgba(255,255,255,.06);font-size:13px;}
        @media(min-width:700px){footer{flex-direction:row;justify-content:space-between;padding:20px 52px;}}
        footer a{color:rgba(255,255,255,.35);text-decoration:none;margin-left:20px;}
        footer a:hover{color:rgba(255,255,255,.7);}
        .ov{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:200;display:flex;align-items:center;justify-content:center;padding:20px;}
        .mo{background:#fff;border-radius:12px;padding:36px 32px;width:100%;max-width:420px;position:relative;}
        .mx{position:absolute;top:14px;right:16px;background:none;border:none;font-size:22px;cursor:pointer;color:#9ca3af;line-height:1;}
        .mx:hover{color:#111;}
        .mot{font-size:20px;font-weight:700;letter-spacing:-.3px;margin-bottom:6px;}
        .mos{font-size:14px;color:#6b7280;margin-bottom:24px;line-height:1.6;}
        .fl{margin-bottom:16px;}
        .fl label{display:block;font-size:13px;font-weight:500;color:#374151;margin-bottom:6px;}
        .fl input{width:100%;padding:10px 12px;border:.5px solid #d1d5db;border-radius:6px;font-size:14px;font-family:inherit;outline:none;transition:border-color .15s;}
        .fl input:focus{border-color:#111;}
        .sb2{width:100%;background:#111;color:#fff;padding:16px;border-radius:100px;font-size:16px;font-weight:600;border:none;cursor:pointer;margin-top:4px;transition:background .15s;}
        .sb2:hover{background:#333;}
        .ok{text-align:center;padding:16px 0;}
        .ok .ic{font-size:36px;margin-bottom:12px;}
        .ok .ot{font-size:18px;font-weight:700;margin-bottom:8px;}
        .ok .os{font-size:14px;color:#6b7280;line-height:1.6;}
      `}</style>

      {open && (
        <div className="ov" onClick={() => setOpen(false)}>
          <div className="mo" onClick={e => e.stopPropagation()}>
            <button className="mx" onClick={() => setOpen(false)}>x</button>
            {done ? (
              <div className="ok">
                <div className="ic">&#10003;</div>
                <div className="ot">Thanks - we will be in touch!</div>
                <div className="os">A member of the unshoot.ai team will reach out within 24 hours.</div>
              </div>
            ) : (
              <>
                <div className="mot">Express interest</div>
                <div className="mos">Tell us about your brand and we will reach out within 24 hours.</div>
                <form onSubmit={sub}>
                  <div className="fl"><label>Name</label><input name="name" placeholder="Your name" value={form.name} onChange={set} required/></div>
                  <div className="fl"><label>Company name</label><input name="company" placeholder="Brand or company" value={form.company} onChange={set} required/></div>
                  <div className="fl"><label>Email</label><input name="email" type="email" placeholder="you@company.com" value={form.email} onChange={set} required/></div>
                  <div className="fl"><label>Contact number</label><input name="phone" placeholder="+971 50 000 0000" value={form.phone} onChange={set}/></div>
                  <button type="submit" className="sb2">Submit</button>
                </form>
              </>
            )}
          </div>
        </div>
      )}

      <nav className="nav">
        <Logo/>
        <button className="ncta nav-hide-mobile" onClick={go}>Try 5 products free</button>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hl">
          <h1 className="ht f2 ht-desktop">On-model photoshoots.<br/>Without the shoot.</h1>
          <h1 className="ht f2 ht-mobile">Model photoshoots.<br/>Without the shoot.</h1>
          <p className="hs f3 hs-desktop">Studio-quality model images from just one product photo — delivered in 24 hours.</p>
          <p className="hs f3 hs-mobile">Turn one product photo into studio quality images.</p>
          <div className="ha f4">
            <button className="bp" onClick={go}>Try 5 products free</button>
          </div>
        </div>
        <div className="hr">
          <div className="is">
            {[
              {img:"https://res.cloudinary.com/deirnhkzy/image/upload/q_auto/f_auto/v1777012126/sku_021_test_pcnc7u.png",l:"abaya"},
              {img:"https://res.cloudinary.com/deirnhkzy/image/upload/q_auto/f_auto/v1777012125/sku_019_test_lkazko.png",l:"occasion"},
              {img:"https://res.cloudinary.com/deirnhkzy/image/upload/q_auto/f_auto/v1777012126/sku_003_ehmlgs.png",l:"casual"}
            ].map((c,i)=>(
              <div key={i} className="mc">
                <div className="mb" style={{background:"#1a1a1a",padding:0,overflow:"hidden"}}>
                  <img src={c.img} alt={c.l} style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"top center",display:"block"}}/>
                  <span className="mt">{c.l}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="dv"/>

      {/* RESULTS */}
      <section className="sec sb" id="results">
        <p className="sl2">Results</p>
        <h2 className="st">From flatlay → to on-model</h2>
        <p className="sd">Turn any product photo into studio-quality model images.</p>
        <div className="bag">
          {[
            {
              l:"Black Dress",
              before:"https://res.cloudinary.com/deirnhkzy/image/upload/q_auto/f_auto/v1777031855/Screenshot_2026-04-21_at_3.05.43_pm_qzvppd.png",
              after:[
                {img:"https://res.cloudinary.com/deirnhkzy/image/upload/q_auto/f_auto/v1777031656/sku_010_avfir4.png",l:"Front"},
                {img:"https://res.cloudinary.com/deirnhkzy/image/upload/q_auto/f_auto/v1777635197/sku_010_back_brlrwa.png",l:"Back"},
                {img:"https://res.cloudinary.com/deirnhkzy/image/upload/q_auto/f_auto/v1777635197/sku_010_angle_pjqfao.png",l:"Alternate"}
              ]
            },
            {
              l:"Yellow T-Shirt",
              before:"https://res.cloudinary.com/deirnhkzy/image/upload/q_auto/f_auto/v1777869252/Input_sku22_pifyl3.png",
              after:[
                {img:"https://res.cloudinary.com/deirnhkzy/image/upload/q_auto/f_auto/v1777869246/sku_022_hygrfx.png",l:"Front"},
                {img:"https://res.cloudinary.com/deirnhkzy/image/upload/q_auto/f_auto/v1777869246/sku_022_back_ubuouo.png",l:"Back"},
                {img:"https://res.cloudinary.com/deirnhkzy/image/upload/q_auto/f_auto/v1777869247/sku_022_angle_weclq8.png",l:"Alternate"}
              ]
            }
          ].map((p,i)=>(
            <div key={i} style={{marginBottom:48}}>
              <div className="ba-grid">
                {/* Before */}
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  <div style={{borderRadius:10,overflow:"hidden",aspectRatio:"2/3",background:"#1a1a1a",position:"relative"}}>
                    <img src={p.before} alt={p.l+" before"} style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"top center",display:"block"}}/>
                    <span style={{position:"absolute",bottom:10,left:10,fontSize:11,fontWeight:600,letterSpacing:1,textTransform:"uppercase",padding:"4px 10px",borderRadius:4,background:"rgba(255,255,255,.92)",color:"#374151"}}>Before</span>
                  </div>
                </div>
                {/* Arrow */}
                <div className="ba-arrow" style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,paddingTop:80}}>
                  <div style={{width:1,height:20,background:"#d1d5db"}}/>
                  <div style={{width:28,height:28,borderRadius:"50%",border:".5px solid #d1d5db",background:"#fff",display:"flex",alignItems:"center",justifyContent:"center"}}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6h8M7 3l3 3-3 3" stroke="#6b7280" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  </div>
                  <div style={{width:1,height:20,background:"#d1d5db"}}/>
                </div>
                {/* After — desktop grid */}
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  <div className="after-grid">
                    {p.after.map((a,j)=>(
                      <div key={j} style={{borderRadius:10,overflow:"hidden",aspectRatio:"2/3",background:"#1a1a1a",position:"relative"}}>
                        <img src={a.img} alt={a.l} style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"top center",display:"block"}}/>
                        <span style={{position:"absolute",bottom:10,left:10,fontSize:11,fontWeight:600,letterSpacing:1,textTransform:"uppercase",padding:"4px 10px",borderRadius:4,background:"#111",color:"#fff"}}>{a.l}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* Mobile layout */}
              <div className="mobile-results">
                {/* Before image */}
                <div style={{borderRadius:10,overflow:"hidden",aspectRatio:"2/3",background:"#1a1a1a",position:"relative"}}>
                  <img src={p.before} alt="Before" style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"top center",display:"block"}}/>
                  <span style={{position:"absolute",bottom:10,left:10,fontSize:11,fontWeight:600,letterSpacing:1,textTransform:"uppercase",padding:"4px 10px",borderRadius:4,background:"rgba(255,255,255,.92)",color:"#374151"}}>Before</span>
                </div>
                {/* Down arrow */}
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,padding:"12px 0"}}>
                  <div style={{width:1,height:16,background:"#d1d5db"}}/>
                  <div style={{width:28,height:28,borderRadius:"50%",border:".5px solid #d1d5db",background:"#fff",display:"flex",alignItems:"center",justifyContent:"center"}}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 2v8M3 7l3 3 3-3" stroke="#6b7280" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  </div>
                  <div style={{width:1,height:16,background:"#d1d5db"}}/>
                </div>
                {/* Scrollable after images */}
                <div className="after-carousel">
                  {p.after.map((a,j)=>(
                    <div key={j} className="after-carousel-item">
                      <div style={{borderRadius:10,overflow:"hidden",aspectRatio:"2/3",background:"#1a1a1a",position:"relative"}}>
                        <img src={a.img} alt={a.l} style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"top center",display:"block"}}/>
                        <span style={{position:"absolute",bottom:10,left:10,fontSize:11,fontWeight:600,letterSpacing:1,textTransform:"uppercase",padding:"4px 10px",borderRadius:4,background:"#111",color:"#fff"}}>{a.l}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="dv"/>

      {/* PAIN */}
      <section className="sec">
        <div className="pain-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:80,alignItems:"center"}}>
          <div>
            <p className="sl2">The Problem</p>
            <h2 className="st" style={{marginBottom:40}}>Photoshoots don't scale</h2>
            <div style={{display:"flex",flexDirection:"column"}}>
              {[
                "Every new product requires a shoot",
                "Shoots take days to plan and execute",
                "Costs add up with every collection",
                "Delays slow down your catalog and sales"
              ].map((t,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:20,padding:"20px 0",borderBottom:".5px solid #e8eaed"}}>
                  <span style={{width:32,height:32,borderRadius:"50%",background:"#f1f3f5",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:12,fontWeight:600,color:"#9ca3af"}}>0{i+1}</span>
                  <span style={{fontSize:17,fontWeight:500,color:"#111",lineHeight:1.5}}>{t}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="pain-img" style={{borderRadius:16,overflow:"hidden",aspectRatio:"4/3",maxHeight:500,boxShadow:"0 24px 60px rgba(0,0,0,0.12)"}}>
            <img src="https://res.cloudinary.com/deirnhkzy/image/upload/q_auto/f_auto/v1777633973/ChatGPT_Image_Apr_29_2026_at_11_04_56_AM_wb8ak4.png" alt="Traditional photoshoot" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
          </div>
        </div>
      </section>

      <div className="dv"/>

      {/* SOLUTION */}
      <section className="sec sb">
        <p className="sl2">The Solution</p>
        <h2 className="st" style={{marginBottom:40}}>Why brands switch to Unshoot</h2>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))",gap:16}}>
          {[
            {icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="m9 12 2 2 4-4"/></svg>,t:"No studio, model, or coordination required",d:"Send one product photo. We handle everything else."},
            {icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,t:"Delivered in 24 hours",d:"From upload to finished images in under a day, every time."},
            {icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>,t:"Works with just one product image",d:"A single flatlay is all we need to generate a full model shoot."},
            {icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>,t:"Consistent model & styling across your catalog",d:"Same look, same feel — every product, every collection."}
          ].map((s,i)=>(
            <div key={i} style={{background:"#fff",border:".5px solid #e8eaed",borderRadius:12,padding:"32px 28px",transition:"box-shadow .2s"}}>
              <div style={{fontSize:24,marginBottom:20,color:"#111"}}>{s.icon}</div>
              <div style={{fontSize:17,fontWeight:600,color:"#111",lineHeight:1.4,marginBottom:10}}>{s.t}</div>
              <div style={{fontSize:15,color:"#6b7280",lineHeight:1.65}}>{s.d}</div>
            </div>
          ))}
        </div>
        <div style={{marginTop:40,textAlign:"center"}}>
          <button className="bp" onClick={go}>Try 5 products free</button>
        </div>
      </section>
      <section className="sec" id="how">
        <p className="sl2">The process</p>
        <h2 className="st">Three steps to campaign-ready images</h2>
        <p className="sd">From a product flatlay to scroll-stopping visuals - no creative team required.</p>
        <div className="hg">
          {[{n:"01",t:"Share your flatlay",d:"Send us any product photo - a flatlay, ghost mannequin or white background. One image is all we need."},{n:"02",t:"Choose your model and setting",d:"Select model diversity, background and styling. Arabic, South Asian and global options available."},{n:"03",t:"Get your final images within 24 hours",d:"High-resolution, e-commerce ready images delivered to you. Ready for Noon, Namshi, DTC sites and social."}].map((s,i)=>(
            <div key={i} className="hc">
              <div className="hn">{s.n}</div>
              <div><div className="htn">{s.t}</div><div className="htd">{s.d}</div></div>
            </div>
          ))}
        </div>
      </section>

      <div className="dv"/>

      {/* COMPARISON */}
      <section className="sec sb">
        <p className="sl2">The Comparison</p>
        <h2 className="st" style={{marginBottom:40}}>Traditional photoshoot vs Unshoot</h2>
        <div style={{borderRadius:16,overflow:"hidden",border:".5px solid #e8eaed",background:"#fff",boxShadow:"0 4px 24px rgba(0,0,0,0.06)"}}>
          {/* Header */}
          <div className="cmp-header" style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr",background:"#111",padding:"20px 32px"}}>
            <div style={{fontSize:12,fontWeight:600,letterSpacing:1.5,textTransform:"uppercase",color:"#fff"}}>Feature</div>
            <div style={{fontSize:12,fontWeight:600,letterSpacing:1.5,textTransform:"uppercase",color:"#fff",textAlign:"center"}}>Photoshoot</div>
            <div style={{fontSize:12,fontWeight:600,letterSpacing:1.5,textTransform:"uppercase",color:"#fff",textAlign:"center"}}>Unshoot</div>
          </div>
          {[
            {f:"Cost per product",a:"AED 200–300",b:"AED 99"},
            {f:"Turnaround time",a:"3–7 days",b:"24 hours"},
            {f:"Effort required",a:"High",b:"None"},
            {f:"Minimum order",a:"20+ SKUs",b:"1 SKU"}
          ].map((r,i)=>(
            <div key={i} className="cmp-row" style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr",padding:"22px 32px",borderTop:".5px solid #f1f3f5",alignItems:"center",fontSize:16}}>
              <div style={{fontWeight:500,color:"#111"}}>{r.f}</div>
              <div style={{textAlign:"center"}}>
                <span style={{fontSize:15,color:"#374151"}}>{r.a}</span>
              </div>
              <div style={{textAlign:"center"}}>
                <span className="cmp-pill" style={{fontSize:16,fontWeight:700,color:"#111",background:"#f1f3f5",padding:"4px 14px",borderRadius:100}}>{r.b}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="dv"/>

      {/* PRICING */}
      <section className="sec" id="pricing">
        <p className="sl2">Pricing</p>
        <h2 className="st">Simple, transparent pricing</h2>
        <p className="sd">Save up to 60–70% vs traditional photoshoots</p>
        <div className="pg" style={{gridTemplateColumns:"repeat(3,1fr)"}}>
          <div className="pc">
            <div className="pn">Trial</div>
            <div className="pp">Free</div>
            <ul className="pf" style={{marginTop:16}}>{checks(["5 products","3 images (front, back, alternate)","Standard resolution","Delivered in 24 hours"],false)}</ul>
            <button className="pb2" onClick={go} style={{border:"2px solid #111",fontWeight:700}}>Try 5 products free</button>
          </div>
          <div className="pc pop">
            <div className="pb">Most popular</div>
            <div className="pn">Growth</div>
            <div style={{display:"flex",alignItems:"baseline",gap:8,marginBottom:4}}>
              <span className="pp">AED 99</span><span className="ps">AED 149</span>
            </div>
            <div style={{marginBottom:16}}>
              <span style={{display:"inline-block",background:"rgba(255,255,255,.15)",color:"#fff",fontSize:11,fontWeight:600,letterSpacing:.8,textTransform:"uppercase",padding:"3px 10px",borderRadius:4}}>Launch offer</span>
            </div>
            <ul className="pf">{checks(["3 images (front, back, alternate)","Ready for e-commerce & ads","Delivered in 24 hours"],true)}</ul>
            <button className="pb2" onClick={go}>Start your first batch</button>
          </div>
          <div className="pc">
            <div className="pn">Enterprise</div>
            <div className="pp">Custom</div>
            <ul className="pf" style={{marginTop:16}}>{checks(["200+ SKUs","3 images (front, back, alternate)","Ready for e-commerce & ads","Delivered in 24 hours"],false)}</ul>
            <button className="pb2" onClick={go} style={{border:"2px solid #111",fontWeight:700}}>Get a quote</button>
          </div>
        </div>
      </section>

      <div className="dv"/>

      {/* GCC */}
      <section className="sec sb" id="features">
        <p className="sl2">Why unshoot.ai</p>
        <h2 className="st">Built for GCC e-commerce</h2>
        <div className="fg">
          {[
            {icon:<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="m9 12 2 2 4-4"/></svg>, t:"Product accuracy, guaranteed",d:"Every detail preserved - fabric texture, color, cut, drape - faithful to your product in every output."},
            {icon:<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>, t:"GCC-native model diversity",d:"Arabic, South Asian, and diverse models that resonate with UAE and KSA shoppers."},
            {icon:<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>, t:"E-commerce ready",d:"Output specs aligned with major marketplace requirements. Upload-ready assets every time."},
            {icon:<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="9" height="9" rx="1"/><rect x="13" y="2" width="9" height="9" rx="1"/><rect x="2" y="13" width="9" height="9" rx="1"/><rect x="13" y="13" width="9" height="9" rx="1"/></svg>, t:"Bulk collection processing",d:"Upload entire catalogues at once. Scale from 10 to 10,000 images with the same quality."}
          ].map((f,i)=>(
            <div key={i} className="fc">
              <div style={{marginBottom:16}}>{f.icon}</div>
              <div className="ftt">{f.t}</div>
              <div className="fdd">{f.d}</div>
            </div>
          ))}
        </div>
      </section>

      <div className="dv"/>

      {/* FINAL CTA */}
      <section className="cta">
        <h2 className="ctat">Your next collection,<br/>without the shoot</h2>
        <button className="ba2" onClick={go}>Try 5 products free</button>
      </section>

      <footer>
        <span>2026 unshoot.ai</span>
        <div><a href="#">Privacy</a><a href="#">Terms</a><a href="#">Contact</a></div>
      </footer>
    </div>
  );
}